export const lightGreyIconButtonStyle = {
	color: 'medepos.1',
	variant: 'light',
	px: 'xs',
};

export const whiteIconButtonStyle = {
	color: 'medepos.1',
	variant: 'white',
	px: 'xs',
};
